/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { createContext } from 'react';
import { m as merge_1 } from '../_chunks/dep-d71ee5f3.js';
import '../locale/zh_CN.js';
import defaultConfig from '../_common/js/global-config/default-config.js';
import zhCN from '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var EAnimationType = /* @__PURE__ */function (EAnimationType2) {
  EAnimationType2["ripple"] = "ripple";
  EAnimationType2["expand"] = "expand";
  EAnimationType2["fade"] = "fade";
  return EAnimationType2;
}(EAnimationType || {});
var defaultClassPrefix = "t";
var defaultAnimation = {
  include: ["ripple" /* ripple */, "expand" /* expand */, "fade" /* fade */],
  exclude: []
};
var defaultGlobalConfig = _objectSpread({
  animation: defaultAnimation,
  classPrefix: defaultClassPrefix
}, merge_1(zhCN, defaultConfig));
var defaultContext = {
  globalConfig: defaultGlobalConfig
};
var ConfigContext = /*#__PURE__*/createContext(defaultContext);

export { EAnimationType, ConfigContext as default, defaultAnimation, defaultClassPrefix, defaultContext, defaultGlobalConfig };
//# sourceMappingURL=ConfigContext.js.map
